import { render } from "./SwitchView.vue?vue&type=template&id=32b2541a&scoped=true"
import script from "./SwitchView.vue?vue&type=script&lang=js"
export * from "./SwitchView.vue?vue&type=script&lang=js"

import "./SwitchView.vue?vue&type=style&index=0&id=32b2541a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b2541a"]])

export default __exports__